var TESNAV = TESNAV || {};

TESNAV.panelToggle = function () {

  function toggle ($trigger, forceAction) {

    var $target = TESNAV.$container.find($trigger.attr('data-target')),
      $targetHide = TESNAV.$container.find($trigger.attr('data-target-hide')),
      $targetFocus = TESNAV.$container.find($trigger.attr('data-target-focus')),
      $pairedTriggers = TESNAV.$container.find($trigger.attr('data-paired-with')),
      fn;

    fn = forceAction ? forceAction + 'Class' : 'toggleClass';
    $trigger[fn]('active');
    fn = ($trigger.hasClass('active')) ? 'addClass' : 'removeClass';
    $target[fn]('active');
    $pairedTriggers[fn]('active');
    $targetHide[fn]('hidden');

    if ($target.hasClass('active')) {
      if ($targetFocus.length) {
        $targetFocus.focus();
      }
    }
  }

  function stretchPanel($panel) {
    var heightDiff,
      viewportHeight,
      documentHeight,
      popupHeight,
      $bodyContent;

    if (TES.viewportWidth.medium.up()) {
      return;
    }

    if (!jQuery('.new-header-wrapper, .js-masthead').length) {
      return;
    }
    $bodyContent = jQuery('body > *').filter(function (){
      return !jQuery.contains(this, $panel.get(0)) && !$panel.is(this);
    });
    if ($panel.hasClass('active')) {
      $panel.css('min-height', 0);
      // stretch popup to height of document (style will take effect on mobile only)
      viewportHeight = jQuery(window).height();
      heightDiff = viewportHeight - $panel.outerHeight();
      // set new document height to match whichever is taller - the popup or the viewport
      documentHeight = (heightDiff < 0) ? $panel.outerHeight() : viewportHeight;
      // account for menu bar above popup
      popupHeight = documentHeight - $panel.offset().top;
      $panel.css('min-height', popupHeight + 'px');
      // Hide contents of body
      $bodyContent.addClass('hidden');
    } else {
      $bodyContent.removeClass('hidden');
    }
  }

  // toggle panels
  TESNAV.$container.on('click', '.js-toggle', function (e) {
    var $trigger,
      targetPanel,
      $otherPanels;

    /* execute the toggle only if:
     - the button hasn't been tagged as 'trigger JS function in small media query only'
     or
     - if it has been tagged as above, then if the viewport is sized small
     */
    $trigger = jQuery(this);
    if (!$trigger.attr('data-js-mq-small-only') || (TES.viewportWidth.small.down())) {
      targetPanel = $trigger.attr('data-target');
      toggle($trigger);
      stretchPanel(TESNAV.$container.find(targetPanel));
      TESNAV.$container.find(targetPanel).on('heightChange', function() {
        stretchPanel(jQuery(this));
      });

      $otherPanels = TESNAV.$container.find('.js-toggle').not('[data-target="' + targetPanel + '"]');
      $otherPanels.each(function () {
        toggle(jQuery(this), 'remove');
      });

      // TODO - fix MZ bug around link clicks / firing double events
      if (!$trigger.is('a') && (typeof _mz !== 'undefined')) {
        _mz.emit(_mze.CLICK, {
          eventTitle: $trigger.attr('data-mz-event-title')
        });
      }
      e.preventDefault();
    }
  });

  //close the panel if clicked outside
  jQuery(document).mouseup(function (e) {
    if(!TESNAV.$container.find('.js-toggle').length) return;
    var $openedPanelsToggles = TESNAV.$container.find('.js-toggle.active[data-close-click-outside]');
    if(!$openedPanelsToggles.length) return;
    $openedPanelsToggles.each(function(){
      var $this = jQuery(this);
      var $panel = jQuery($this.attr('data-target'));
      if($panel.find(e.target).length === 0 && $(e.target).closest('.js-toggle')[0] !== $(this)[0]) {
        $this.click();
      }
    });
  });

  //load panel if previous state is found cookie
  TESNAV.$container.find('.js-toggle').each(function () {
    var $this = jQuery(this);
    var previousStateCookieName = $this.attr('data-previous-state-cookie-name');
    if (previousStateCookieName) {
      if (Cookies) {
        if (Cookies.get(previousStateCookieName)) {
          $this.click(); //show it
        }
        $this.click(function () {
          setTimeout(function () { //make sure menu opening and closing is finished
            //cookie needs to be set on domain, not just sub domain
            var topLevelDomain = window.location.hostname.split('.');
            topLevelDomain.shift();
            topLevelDomain = topLevelDomain.join('.');
            if ($this.hasClass('active')) {
              Cookies.set(previousStateCookieName, 'true', {
                domain: topLevelDomain,
                expires: '01/01/2030'
              });
            }
            else {
              Cookies.set(previousStateCookieName, undefined, {
                domain: topLevelDomain,
                expires: '01/01/1970'
              });
            }
          }, 0);//setTimeout
        }); // $this.click
      } //if(Cookie)
    }// if(previousStateCookieName)
  });
};
